// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__KyNUI","box":"WorkspacesBox_box__8mn_r","node":"WorkspacesBox_node__6_Il6"};